<template>
  <div class="bug">
    <img
      v-for="img in pageInfo.pic_url"
      :key="img"
      :src="img"
      alt=""
    >
  </div>

</template>

<script type="text/ecmascript-6">
import bugReport from "@/apis/bugReport/index.js";

export default {
  data() {
    return {
      pageInfo: {},
    };
  },
  components: {},
  created() {
    this.getBugReport();
  },
  methods: {
    getBugReport() {
      const params = {
        id: this.$route.query.id,
      };
      bugReport.getBugReport(params).then((res) => {
        res.pic_url = JSON.parse(res.pic_url);
        this.pageInfo = res;
      });
    },
  },
};
</script>

<style scoped lang="less">
.bug {
  img {
    width: 100%;
    height: auto;
  }
}
</style>
